export let UseCaseOption;

(function (UseCaseOption) {
  UseCaseOption["TrackDeals"] = "track-deals";
  UseCaseOption["EmailMarketing"] = "email-marketing";
  UseCaseOption["ConnectLeads"] = "connect-leads";
})(UseCaseOption || (UseCaseOption = {}));